import { render, staticRenderFns } from "./element.vue?vue&type=template&id=0bd2d0f4"
import script from "./element.ts?vue&type=script&lang=js&external"
export * from "./element.ts?vue&type=script&lang=js&external"
import style0 from "./element.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports